import { parse as parseQuerystring } from 'querystring';

import { getFixedQueryString } from './query';

export type UtmParams = {
  source?: string;
  medium?: string;
  campaign?: string;
  campaignAdGroup?: string;
  term?: string;
  content?: string;
};

type UtmQueryParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

const STORAGE_KEY = 'utm_params';

export const getUtmParamsFromUrl = () => {
  if (typeof window === 'undefined') return {};
  const query: UtmQueryParams = parseQuerystring(
    getFixedQueryString(location.search.replace(/^\?/, '')),
  );

  const campaign = query.utm_campaign
    ? query.utm_campaign.split('|')
    : undefined;

  const utm: UtmParams = {
    source: query.utm_source || document.referrer || '',
    medium: query.utm_medium || '',
    campaign: campaign?.length ? campaign[0] : '',
    campaignAdGroup: campaign && campaign.length > 1 ? campaign[1] : '',
    term: query.utm_term || '',
    content: query.utm_content || '',
  };

  return utm;
};

export const persistUtm = () => {
  const utm = getUtmParamsFromUrl();
  if (typeof sessionStorage === 'undefined') return;

  // prevent overwriting existing UTMs
  const currentValue = sessionStorage.getItem(STORAGE_KEY);
  if (currentValue) return;

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
};

export const getUtm = () => {
  if (typeof sessionStorage === 'undefined') return getUtmParamsFromUrl();
  const storedParams = sessionStorage.getItem(STORAGE_KEY) || '';
  try {
    return JSON.parse(storedParams) as UtmParams;
  } catch (_err: any) {
    // Exception ignored - storage is probably empty
  }
  return getUtmParamsFromUrl();
};
